// extracted by mini-css-extract-plugin
export default {"link":"AK-z","disabled":"BK-z"};